var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99957 5.75C5.99957 5.55109 6.07859 5.36032 6.21924 5.21967C6.3599 5.07902 6.55066 5 6.74957 5H12.7496C12.9485 5 13.1393 5.07902 13.2799 5.21967C13.4206 5.36032 13.4996 5.55109 13.4996 5.75V11.75C13.4996 11.9489 13.4206 12.1397 13.2799 12.2803C13.1393 12.421 12.9485 12.5 12.7496 12.5C12.5507 12.5 12.3599 12.421 12.2192 12.2803C12.0786 12.1397 11.9996 11.9489 11.9996 11.75V7.5605L5.77982 13.7803C5.63837 13.9169 5.44892 13.9925 5.25227 13.9908C5.05562 13.989 4.86752 13.9102 4.72846 13.7711C4.5894 13.6321 4.51053 13.4439 4.50882 13.2473C4.50711 13.0507 4.5827 12.8612 4.71932 12.7197L10.9391 6.5H6.74957C6.55066 6.5 6.3599 6.42098 6.21924 6.28033C6.07859 6.13968 5.99957 5.94891 5.99957 5.75Z",
    fill: "#4F3EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightUp);
export default __webpack_public_path__ + "static/media/arrow-right-up.56ce7cc535730c54ebc228e8ded50e4d.svg";
export { ForwardRef as ReactComponent };